import { getPlatformType, ios, android } from '@/helpers/deviceHelpers'
import { sleep } from '@/helpers/supportHelpers'
import firebase from 'firebase/app';
import 'firebase/auth';
import { requestRefreshToken } from "@/helpers/deviceHelpers"

export default class TokenManager
{
    firebaseConfig = {
        apiKey: "AIzaSyAWthWvENjJt4G7qAcG4ZZlxtIlrV6plUE",
        authDomain: "skitude-com-api-project-78343916704.firebaseapp.com",
        databaseURL: "https://skitude-com-api-project-78343916704.firebaseio.com",
        projectId: "skitude.com:api-project-78343916704",
        storageBucket: "undefined",
        messagingSenderId: "78343916704",
        appId: "1:78343916704:web:b45965251a4c45077acdc5",
        measurementId: "G-W0XXEWYX44"
    };
    appRenewedToken = undefined
    appRequestTimeout = 5000;
    appRequestsleepInterval = 100; 

    getFirebaseSDK()
    {
        this.initFirebase();
        return firebase;
    }

    refreshToken() 
    {
        const platform = getPlatformType();

        switch(platform) {
          case android:
          case ios:
              return this.refreshAppToken(platform)
          default:
              return this.refreshFirebaseToken();
        }
    }

    refreshAppToken(platform)
    {
        this.appRenewedToken = undefined
        
        console.debug('Platform ' + platform + ': Sending request to device');
        this.setTokenRecievedEventListener()
        requestRefreshToken(platform);
        
        console.debug('Platform ' + platform + ': Waiting for device response');
        return this.createAppResponsePromise();
    }

    setTokenRecievedEventListener()
    {
        window.addEventListener('jwtTokenRenewed', (payload) => {
            this.appRenewedToken = payload.detail
        });
    }

    createAppResponsePromise()
    {
        return this.createSleepAndProcessLoop();
    }

    createSleepAndProcessLoop(timeElapsed = 0)
    {
        const me = this
        return sleep(me.appRequestsleepInterval)
            .then(() => {
                if (timeElapsed > me.appRequestTimeout) {
                    console.debug("Platform: Token request Timeout.")
                    return Promise.reject("Token request Timeout");
                }

                if (me.appRenewedToken) {
                    console.debug("Platform: Token has been recieved.")
                    return me.appRenewedToken;
                }
                
                console.debug("Platform: Token has not been recieved yet. Sleeping " + me.appRequestsleepInterval + " ms.")
                return me.createSleepAndProcessLoop(timeElapsed + me.appRequestsleepInterval)
            })
    }

    refreshFirebaseToken()
    {
        this.initFirebase();

        return this.getFirebaseUser()
            .then((user) => {
                return user.getIdToken()
            });
    }

    initFirebase() 
    {
        if (firebase.apps.length === 0) {
            console.debug('Firebase SDK: Initializing');
            firebase.initializeApp(this.firebaseConfig);
            console.debug('Firebase SDK: Initialized ✅');
        }
    }

    async getFirebaseUser()
    {
        let currentUser = await this.getFirebaseUserFromPreviousLogin();
        if (!currentUser) {
            console.debug('Firebase SDK: No user logged in. Loging an anonymous account');
            return this.loginFirebaseUser();
        }
        
        console.debug('Firebase SDK: User logged in. Retrieving current user');
        return new Promise((resolve, reject) => {
            const user = firebase.auth().currentUser;
            if (!user) {
                reject();
            }
            resolve(user);
        });
    }

    getFirebaseUserFromPreviousLogin() {
        return new Promise((resolve, reject) => {
            const unsubscribe = firebase.auth().onAuthStateChanged(user => {
                unsubscribe();
                resolve(user);
            }, () => reject('Firebase API Failed'));
        });
      }

    loginFirebaseUser()
    {
        return firebase.auth().signInAnonymously()
            .then((response) => {
                console.debug('Firebase SDK: Login anonymous successfull ✅');
                return response.user;
            })
            .catch(function(error) {                
                if (error.code === 'auth/operation-not-allowed') {
                    alert('You must enable Anonymous auth in the Firebase Console.');
                }
                console.error(error);
            });
    }

    parseJwt (token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );

        return JSON.parse(jsonPayload);
    }

    isTokenAnonymous(token) {
        return !token || this.parseJwt(token).provider_id === "anonymous"
    }

    logout() {
        firebase.auth().signOut();
    }
}
